export enum FinzyVersion {
    FINZY_V1 = 'FINZY_V1',
    FINZY_V2 = 'FINZY_V2'
}